import { render, staticRenderFns } from "./oncallReminder.vue?vue&type=template&id=a8ffcecc&scoped=true&"
import script from "./oncallReminder.vue?vue&type=script&lang=ts&"
export * from "./oncallReminder.vue?vue&type=script&lang=ts&"
import style0 from "./oncallReminder.vue?vue&type=style&index=0&id=a8ffcecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ffcecc",
  null
  
)

export default component.exports